import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  label: {
    id: '@lib.core.DateRangePickerAvailabilities.label',
    defaultMessage: 'Date Range',
  },
  fewer: {
    id: '@lib.core.DateRangePickerAvailabilities.fewer',
    defaultMessage: 'fewer',
  },
  more: {
    id: '@lib.core.DateRangePickerAvailabilities.more',
    defaultMessage: 'more',
  },
  cancel: {
    id: '@lib.core.DateRangePickerAvailabilities.cancel',
    defaultMessage: 'CANCEL',
  },
});
